/**
 * Users API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { getMe, patchMe, updateUserFinaSettings, updateUserFursSettings } from "../generated/users/users";

import { wrapMethod } from "./utils";

export const users = {
  /** @see getMe */
  getMe: wrapMethod(getMe),

  /** @see patchMe */
  update: wrapMethod(patchMe),

  /** @see updateUserFursSettings */
  updateFursSettings: wrapMethod(updateUserFursSettings),

  /** @see updateUserFinaSettings */
  updateFinaSettings: wrapMethod(updateUserFinaSettings),
} as const;

export type UsersApi = typeof users;
